import { clampStat, type Stats as LifeStats } from '@life/engine';
import { t } from '@life/i18n';

const KEYS = ['health', 'happiness', 'knowledge', 'relations'] as const;

/**
 * Четыре состояния: значение в моно, полоска 3px без цветового кодирования
 * (цифра — факт, а не оценка). Пояснение из спецификации 4.2 — в `title`.
 */
export function Stats({ stats }: { stats: LifeStats }) {
  return (
    <div class="stats">
      {KEYS.map((k) => {
        const v = Math.round(clampStat(stats[k]));
        return (
          <div class="stat" key={k} title={t(`ui.stats.${k}.title`)}>
            <div class="k">{t(`ui.stats.${k}`)}</div>
            <div class="v">{v}</div>
            <div class="b" aria-hidden="true">
              <i style={{ width: `${v}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
